import Pill from "../common/Pill";
import Arrow from "../../assets/Arrow.svg";
import Logo from "../../assets/blog-logo.png";

const HeroSection = () => {
    return (
        <section className="bg-[#111219] flex flex-col justify-center items-center py-20 md:py-28">
            <div className="flex sm:flex-row gap-20 flex-col max-w-6xl mx-auto px-4">
                <div className="flex flex-col items-center sm:items-start gap-4 md:w-1/2 w-full">
                    <Pill text="blogs" backgroundColor="#FFFFFF1A" />

                    <h1 className="text-[#E1E1E1] font-semibold text-[32px] leading-[40px] md:text-[45px] md:leading-[56px] max-w-full">
                        Easy-to-use Voice Ai Technology
                    </h1>

                    <p className="text-gray-300">
                        Make your physical space a conversation. Learn more to standout in your market.
                    </p>
                </div>
                
                <div className="md:w-1/2 w-full flex justify-center">
                    <div className="relative w-full flex items-center justify-center rounded-3xl border border-gray-700 overflow-hidden">
                        <div className="absolute inset-0 bg-gray-400/10"></div>
                        <div className="absolute -top-20 -right-20 w-52 h-52 bg-red-900/80 rounded-full blur-3xl"></div>
                        <div className="absolute bottom-2 left-5 w-32 h-32 bg-red-900/90 rounded-full blur-3xl"></div>
                        <div className="relative p-8 flex items-center justify-center">
                            <div className="flex gap-2 items-center justify-center">
                                <img src={Logo} alt="logo" className="w-12 h-12" />
                                <div className="h-8 w-[1px] bg-gray-400/30" />
                                <span className="text-gray-300 ml-2">Easy-to-use Voice Ai Technology</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="animate-bounce rounded-[70px] mx-auto w-fit h-[60px] px-[15px] py-[20px] mt-12 border border-[#BF2929]">
                <img src={Arrow} alt="down arrow" className="w-full" />
            </div>
        </section>
    );
};

export default HeroSection;